exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.editing-group[data-v-17e56ef2] {\n    border: 2px solid #007bff;\n    /* Blue border or any color you prefer */\n    background-color: #f0f8ff;\n    /* Light blue background for better contrast */\n    box-shadow: 0 0 10px rgba(0, 123, 255, 0.3);\n    /* Light shadow for emphasis */\n}\n.editing-group strong[data-v-17e56ef2] {\n    color: #0056b3;\n    /* Darker text for the group name when editing */\n}\n", ""]);

// exports
